import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, BookCopy, FolderTree, ClipboardList, ArrowRight } from "lucide-react";
import api from "../../lib/api";

function StatCard({ icon: Icon, label, value, to }) {
  return (
    <Link
      to={to}
      className="group block bg-white border border-slate-200 hover:border-gc-green rounded-sm p-5 transition-all"
      data-testid={`admin-stat-${label.toLowerCase()}`}
    >
      <div className="flex items-start justify-between">
        <div className="h-10 w-10 rounded-sm bg-gc-green/5 group-hover:bg-gc-green flex items-center justify-center transition-colors">
          <Icon className="h-5 w-5 text-gc-green group-hover:text-gc-gold-light transition-colors" />
        </div>
        <ArrowRight className="h-4 w-4 text-slate-300 group-hover:text-gc-gold transition-colors" />
      </div>
      <div className="mt-5 font-display text-3xl font-bold text-slate-900">{value ?? "—"}</div>
      <div className="text-xs uppercase tracking-[0.18em] font-semibold text-slate-500 mt-1">{label}</div>
    </Link>
  );
}

export default function AdminOverview() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/overview").then((r) => setData(r.data)).catch(console.error);
  }, []);

  return (
    <div className="p-8 max-w-6xl mx-auto">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-gc-gold mb-2">Panel administración</div>
      <h1 className="font-display text-3xl font-bold text-slate-900">Resumen</h1>
      <p className="mt-2 text-sm text-slate-600">Estado general de la plataforma.</p>

      <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard icon={Users} label="Usuarios" value={data?.users} to="/admin" />
        <StatCard icon={BookCopy} label="Preguntas" value={data?.questions} to="/admin/questions" />
        <StatCard icon={FolderTree} label="Categorías" value={data?.categories} to="/admin/categories" />
        <StatCard icon={ClipboardList} label="Tests realizados" value={data?.results} to="/admin" />
      </div>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
        <Link to="/admin/import" className="block bg-gc-green text-white rounded-sm p-6 hover:bg-gc-green-light transition-colors">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-gc-gold-light mb-2">Importar masivo</div>
          <div className="font-display text-xl font-semibold">Sube CSV, Excel, Word o PDF</div>
          <p className="text-sm text-slate-200 mt-2">Carga cientos de preguntas en segundos desde tu propio archivo.</p>
        </Link>
        <Link to="/admin/questions" className="block bg-white border border-slate-200 rounded-sm p-6 hover:border-gc-green transition-colors">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-gc-gold mb-2">Edición manual</div>
          <div className="font-display text-xl font-semibold text-slate-900">Crea preguntas una a una</div>
          <p className="text-sm text-slate-600 mt-2">Añade, edita o elimina preguntas individualmente con el editor.</p>
        </Link>
      </div>
    </div>
  );
}
